import clone from "clone";

export class CompanyAdministrator
{
	public constructor()
	{
		this.firstName = "";
		this.lastName = "";
		this.email = "";
		this.phoneNumber = "";
	}

	public firstName: string;

	public lastName: string;

	public email: string;

	public phoneNumber: string;

	/**
	 * Gets a clone of this instance, suitable for editing.
	 */
	public clone(): any
	{
		return clone(this);
	}
}
